import { computed } from "mobx";
import { Model, prop } from "mobx-keystone";
import { nsModel } from "../lib/namespace";
import type { InvoiceStore } from "./invoice/store.invoice";
import type { MeterStore } from "./meter/store.meter";
import type { MeterReadingStore } from "./meter/store.meter-reading";
import type { NudgeStore } from "./nudge/store.nudge";
import type OrganizationModel from "./organization/model.organization";
import type {
  AutoPayEnrollmentStore,
  PaymentMethodStore,
  PaymentStore,
} from "./payment/store.payment";
import type { ServiceAccountStore } from "./service-account/store.service-account";
import type UserModel from "./user/model.user";
import type { UserContactStore } from "./user/store.user-contact";

const tillixNs = nsModel("x");

@tillixNs.model
export default class TilliXStore extends Model({
  user: prop<UserModel>(),
  organization: prop<OrganizationModel>(),
  serviceAccounts: prop<ServiceAccountStore>(),
  invoices: prop<InvoiceStore>(),
  meters: prop<MeterStore>(),
  meterReadings: prop<MeterReadingStore>(),
  paymentMethods: prop<PaymentMethodStore>(),
  payments: prop<PaymentStore>(),
  autoPayEnrollments: prop<AutoPayEnrollmentStore>(),
  notifications: prop<NudgeStore>(),
  contacts: prop<UserContactStore>(),
}) {
  @computed
  get ready() {
    for (const key in this.$) {
      if (!this[key as keyof typeof this.$].initialized) {
        return false;
      }
    }

    return true;
  }
}
